var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEligetuconductor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "53px",
    viewBox: "0 0 76 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/driver") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/driver",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38,0 C23.3640927,0 11.5,11.8640927 11.5,26.5 C11.5,41.1359073 23.3640927,53 38,53 C52.6359073,53 64.5,41.1359073 64.5,26.5 C64.5,11.8640927 52.6359073,0 38,0 Z M38,5.12903226 C48.9141532,5.12903226 57.929496,13.3589919 59.2021371,23.9354839 L50.156875,23.9354839 C48.7837903,20.4402621 45.3964919,17.9516129 41.4193548,17.9516129 L34.5806452,17.9516129 C30.6035081,17.9516129 27.2162097,20.4402621 25.843125,23.9354839 L16.7978629,23.9354839 C18.0715726,13.3589919 27.0858468,5.12903226 38,5.12903226 Z M38,33.9851815 L30.4133065,26.400625 C30.8471371,24.5018145 32.5504032,23.0817137 34.5806452,23.0817137 L41.4193548,23.0817137 C43.4495968,23.0817137 45.1528629,24.5028831 45.5866935,26.400625 L38,33.9851815 Z M16.7978629,29.0645161 L25.8249597,29.0645161 L35.4354839,38.6739718 L35.4354839,47.7021371 C25.7010081,46.5299395 17.9700605,38.7989919 16.7978629,29.0645161 Z M40.5645161,47.7021371 L40.5645161,38.6739718 L50.1750403,29.0645161 L59.2021371,29.0645161 C58.0310081,38.7989919 50.2989919,46.5299395 40.5645161,47.7021371 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEligetuconductor);
export default __webpack_public_path__ + "static/media/icon_eligetuconductor.e39d215c150282aa8b392c6e999202de.svg";
export { ForwardRef as ReactComponent };